/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { Grid } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { buildRequiredSchema } from 'utils';
import {
  DialogDefaultV2,
  InputV2,
  NumberInputV2,
  OptionSelectV2,
} from '../../../../components/v2';

const ManutencaoFormulario = ({ open, onClose, onSave, selectedManutencao }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedManutencao) {
      setValues(selectedManutencao);
    } else {
      setValues({});
    }
  }, [selectedManutencao]);

  const onCloseLocal = () => {
    setErrors({});
    setValues({});
    onClose();
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const onSaveLocal = () => {
    const erros = validate(values, buildRequiredSchema(['tipoManutencaoId', 'valor', 'quantidade']));
    setErrors(erros || {});
    if (!erros) {
      let data = values;
      if (!data.id) {
        data = { ...data, id: uuidv4() };
      }
      onSave(data);
      setValues({});
    }
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCloseLocal}
      handlerConfirm={onSaveLocal}
      title="Manutenção"
      confirmMessage={selectedManutencao ? 'Atualizar' : 'Adicionar'}
      maxWidth="md"
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <OptionSelectV2
            label="Tipo de Manutenção"
            codigo="MANUTENCAO_VEICULAR_TIPO"
            isRequired
            onSelect={(tipoManutencaoId, tipoManutencaoNome) =>
              setValues({ ...values, tipoManutencaoId, tipoManutencaoNome })
            }
            value={values.tipoManutencaoId}
            error={!!(errors && errors.tipoManutencaoId)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <NumberInputV2
            error={!!(errors && errors.valor)}
            isRequired
            label="Valor"
            prefix="R$ "
            onChange={(valor) => setValues({ ...values, valor })}
            value={values.valor}
            decimalScale={2}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Quantidade"
            name="quantidade"
            onChange={handleChange}
            value={values.quantidade || ''}
            error={!!(errors && errors.quantidade)}
            isRequired
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <InputV2
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao || ''}
            rows={2}
            multiline
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

ManutencaoFormulario.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  selectedManutencao: PropTypes.object,
};

ManutencaoFormulario.defaultProps = {
  selectedManutencao: null,
};

export default ManutencaoFormulario;
